export const MEDIA_QUERY_MOBILE = '(max-width: 768px)';
export const COURSE_CONTAINER_MOBILE_QUERY = '(max-width: 600px)';

export const COURSE_CONTAINER_ANIMATION_TIMEOUT = 200;
